const MobileQuestionsCell = ({ cell: { value } }) => {
    return value ? 'Yes' : 'No';
};

export default MobileQuestionsCell;
